import mercury from './mercuryAuth.component';
import stMercuryButton from './mercuryButton.component';

export default angular
  .module('st.Integrations.Mercury', ['st.Core', 'angular-cache'])
  .component('mercury', mercury)
  .component('stMercuryButton', stMercuryButton)
  .service('mercuryService', ($http, dataService, MERCURY) => {
    return {
      connect: (params) =>
        dataService.apiRequest(null, null, true, null, $http.get, MERCURY.API.CONNECT, {
          params
        })
    };
  })
  .constant('MERCURY', {
    API: {
      CONNECT: '/api/v1/integration/mercury/connect'
    }
  });
